import { render, staticRenderFns } from "./RefsThg.vue?vue&type=template&id=21ffbfda&scoped=true"
import script from "./RefsThg.vue?vue&type=script&lang=ts"
export * from "./RefsThg.vue?vue&type=script&lang=ts"
import style0 from "./RefsThg.vue?vue&type=style&index=0&id=21ffbfda&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ffbfda",
  null
  
)

export default component.exports